import { zodResolver } from '@hookform/resolvers/zod';
import { extractTextWithNewLinesFromHtml } from '@talentmesh/rte';
import { useForm, useFormContext } from 'react-hook-form';
import { z } from 'zod';
import { useCandidatesResultsContext } from '../../../Contexts/CandidateResultsContext';
import ValidationErrors from '@/Utils/ValidationErrors';

export const ApplicantResultsNoteLengthLimit = 1250;

export const noteValidationSchema = z.object({
    noteRte: z
        .string()
        .refine(
            (value) => extractTextWithNewLinesFromHtml(value || '').length <= ApplicantResultsNoteLengthLimit,
            ValidationErrors.RecruitersNoteInputLengthValidation(ApplicantResultsNoteLengthLimit),
        ),
});

export type CandidatesNoteForm = z.infer<typeof noteValidationSchema>;

export const useCandidatesNoteForm = () => {
    const { results } = useCandidatesResultsContext();
    return useForm<CandidatesNoteForm>({
        resolver: zodResolver(noteValidationSchema),
        defaultValues: { noteRte: results.note ?? '' },
    });
};

export const useCandidatesNoteFormContext = () => useFormContext<CandidatesNoteForm>();
